import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as styles from './PageHeader.module.scss'

const PageHeader = ({ subtitle }) => {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.heading}>
            <h1>
              Top GIS <br />
              Data Sources
            </h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
    </>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default PageHeader
